import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { LegalPage } from "../components/LegalPage";
import { Seo } from "../components/Seo";

export default function TermsPage() {
  const { t } = useI18n();
  return (
    <>
      <Seo k="terms" />
      <LegalPage data={t.termsPage} testid="terms-page" />
    </>
  );
}
